import { SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { filteredDataGraphic } from 'v2/resources/utils/filteredDataGraphic';
import { useQueryQualityParameters } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IGraphicInfo } from 'v2/resources/types/graphics';
import { setGraphicQualityParameters } from 'v2/store/dataChat/slice';

const useWaterQualityParameters = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);

  const [selectedParameter, setSelectedParameter] = useState<string>('default');
  const [selectedNurseries, setSelectedNurseries] = useState<IGraphicInfo[]>(
    []
  );

  const { data: dataQualityParameters } = useQueryQualityParameters(
    selectedCycle?.id
  );

  const handleChangeParameters = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (String(value).includes('default')) {
      return;
    }
    setSelectedParameter(value as string);
  };

  const handleLoadData = useCallback(() => {
    if (!dataQualityParameters) return;

    if (dataQualityParameters.labels?.length === 0) {
      setSelectedParameter('default');
    }
    setSelectedParameter(dataQualityParameters.labels[0] ?? 'default');
    dispatch(setGraphicQualityParameters(dataQualityParameters));
  }, [dataQualityParameters]);

  const optionsParameters = useMemo(() => {
    const defaultOption = [
      {
        id: 1,
        label: 'Parâmetros',
        value: 'default',
      },
      {
        id: 2,
        label: 'Parâmetros',
        value: 'default2',
      },
    ];

    if (!dataQualityParameters) return defaultOption;

    if (dataQualityParameters.labels?.length === 0) return defaultOption;

    return [
      ...[defaultOption[0]],
      ...dataQualityParameters?.labels.map((label, index) => ({
        id: index + 1,
        label: label,
        value: label,
      })),
    ];
  }, [dataQualityParameters]);

  const optionsnNurseries = useMemo(() => {
    if (!dataQualityParameters) return [];

    const result = filteredDataGraphic(
      dataQualityParameters,
      selectedParameter
    );

    setSelectedNurseries(result);
    return result;
  }, [dataQualityParameters, selectedParameter]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);

  return {
    optionsParameters,
    selectedParameter,
    optionsnNurseries,
    selectedNurseries,

    handleChangeParameters,
    setSelectedNurseries,
  };
};
export default useWaterQualityParameters;
